import { render } from "./ApiDocSectionEditor.vue?vue&type=template&id=fa3d6dbc&scoped=true"
import script from "./ApiDocSectionEditor.vue?vue&type=script&lang=js"
export * from "./ApiDocSectionEditor.vue?vue&type=script&lang=js"

import "./ApiDocSectionEditor.vue?vue&type=style&index=0&id=fa3d6dbc&scoped=true&lang=css"
import "./ApiDocSectionEditor.vue?vue&type=style&index=1&id=fa3d6dbc&lang=css"

import exportComponent from "/codebuild/output/src710843524/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa3d6dbc"]])

export default __exports__